export default __webpack_public_path__ + "static/media/youtubeFalid.d2d5a739.png";